import { BranchUserProperties, UserBranchProperties } from '../ClientAPIHelpers/branchProperties';
import { BRANCHES, USERS } from '../constants';
import { FetchAPI } from '../Main/fetchAPI';

export const Branch = {
	getUserBranches: (id: string) =>
		FetchAPI.getJson({
			urlStr: `${USERS}/${id}/branches`,
		}),
	addUserToBranch: (data: UserBranchProperties) =>
		FetchAPI.postJson({
			urlStr: `${USERS}/${data.userId}/branches`,
			data,
		}),
	addBranchToUser: (data: BranchUserProperties) =>
		FetchAPI.postJson({
			urlStr: `${BRANCHES}/${data.branchId}/users`,
			data,
		}),
};
